import React, { useState, useEffect, useCallback } from 'react';

const AdminDashboard = ({ apiUrl, token }) => {
  const [pendingUsers, setPendingUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPendingUsers = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${apiUrl}/api/getPendingUsers`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      setPendingUsers(data);
    } catch (error) {
      console.error("Error fetching pending users:", error);
      alert("Error al cargar los usuarios pendientes.");
    } finally {
      setLoading(false);
    }
  }, [apiUrl, token]);

  useEffect(() => {
    fetchPendingUsers();
  }, [fetchPendingUsers]);

  const handleApprove = async (email) => {
    if (!window.confirm(`¿Estás seguro de que quieres aprobar al usuario ${email}?`)) {
      return;
    }
    await fetch(`${apiUrl}/api/approveUser`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ email }),
    });
    alert(`Usuario ${email} aprobado.`);
    fetchPendingUsers();
  };

  if (loading) return <p>Cargando usuarios pendientes...</p>;

  return (
    <div className="view-container">
      <h2>Panel de Administrador</h2>
      <div className="card">
        <h3>Aprobar Usuarios Pendientes</h3>
        {pendingUsers.length === 0 ? (
          <p>No hay usuarios pendientes de aprobación.</p>
        ) : (
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {pendingUsers.map((user, i) => (
              <li key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderBottom: '1px solid #eee' }}>
                <div>
                  <strong>Email:</strong> {user[0]} <br />
                  <strong>Rol Solicitado:</strong> {user[2]}
                </div>
                <button onClick={() => handleApprove(user[0])}>Aprobar</button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;